import React from 'react';
import { LoginStep } from './login-step/login-step';
import { PasswordStep } from './password-step/password-step';

export const FormLoginUser: React.FC = () => {
    return (
        <>
            <LoginStep />
            <PasswordStep />
        </>
    );
};
